<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else class="grid_row">
      <v-card elevation="6">
        <div class="pa-2">
          <v-slide-x-reverse-transition>
            <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
            <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
          </v-slide-x-reverse-transition>
          <div class="grid_half">
            <div class="grid_list pa-4">
              <div class="mr-1">
                <div>เพิ่มสินค้าเข้าคลังด้วยใบเสร็จ</div>
                <div class="pl-3 pt-1 grey--text">{{ header_list.receipt_no }}</div>
              </div>
              <div class="mr-1">
                <div>วันที่ใบเสร็จ (วัน/เดือน/ปี)</div>
                <div class="pl-3 pt-1 grey--text">{{ date }}</div>
              </div>
              <div class="mr-1">
                <div>ชื่อ บริษัท/Supplier Name</div>
                <div class="pl-3 pt-1 grey--text">{{ header_list.supplier_name }}</div>
              </div>
            </div>
            <div class="ma-4">
              <div class="ml-1">
                <div>ภาษีการซื้อ :</div>
              </div>
              <div class="grey--text mr-1">
                <div class="pl-3 pt-1" v-if="header_list.vat_type === 0">
                  ภาษีรวมใน
                </div>
                <div class="pl-3 pt-1" v-if="header_list.vat_type === 1">
                  ภาษีแยกนอก
                </div>
                <div class="pl-3 pt-1" v-if="header_list.vat_type === 2">
                  ไม่กระทบภาษี
                </div>
                <div class="pl-3 pt-1" v-if="header_list.vat_type === 3">
                  ภาษีเป็น 0
                </div>
              </div>
            </div>
          </div>
          <div class="grid_half">
            <div v-if="header_list.is_credit === 1">
              <div class="grid_list pa-4">
                <div class="mr-1">
                  <div>วันที่ครบกำหนด (วัน/เดือน/ปี)</div>
                  <div class="pl-3 pt-1 grey--text">{{ date_due }}</div>
                </div>
              </div>
            </div>
            <div v-else></div>
            <div class="ma-4">
              <div class="ml-1">
                <div>ประเภท :</div>
              </div>
              <div class="grey--text mr-1">
                <!-- <div class="pl-3 pt-1" v-if="header_list.is_credit === 0">
                  เงินสด
                </div>
                <div class="pl-3 pt-1" v-else-if="header_list.is_credit === 1">
                  เครดิต
                </div>
                <div v-else>-</div> -->
                <div class="pl-3 pt-1">
                  เครดิต
                </div>
              </div>
            </div>
          </div>
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="Pr_List" :items="data_list" key="index" :search="search" mobile-breakpoint="0" hide-default-footer>
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.index +1 }}</td>
                <td>{{ dataDetail.item.product_code }}</td>
                <td>{{ dataDetail.item.lot_no }}</td>
                <td>{{ dataDetail.item.product_name }}</td>
                <td>{{ dataDetail.item.unit }}</td>
                <td>{{ dataDetail.item.date_expired }}</td>
                <td>{{ format_number(dataDetail.item.quantity) }}</td>
                <td>{{ format_Price(dataDetail.item.price) }}</td>
                <td>
                  <div v-if="dataDetail.item.discount_unit !== null">{{ dataDetail.item.discount_unit }}</div>
                  <div v-else>0.00</div>
                </td>
                <td>
                  <div v-if="dataDetail.item.discount_percent !== null">{{ dataDetail.item.discount_percent }}</div>
                  <div v-else>0</div>
                </td>
                <td>{{ format_Price(dataDetail.item.total_price = (( (dataDetail.item.price) - ((dataDetail.item.price * dataDetail.item.discount_percent) / 100)) * dataDetail.item.quantity) - dataDetail.item.discount_unit) }}</td>
                <td>
                  <div class="text-center" v-if="dataDetail.item.exchange_status !== 0">รอคืน</div>
                  <div class="text-center" v-else>-</div>
                </td>
              </tr>
            </template>
            <template v-slot:body.append>
              <tr>
                <td colspan="9" class="pa-2 border_col">
                  <div class="ma-4">
                    <div class="text-center">รวม</div>
                  </div>
                </td>
                <td colspan="4" class="pa-2 border_col">
                  <div class="ma-4">
                    <div class="text-center">{{ total }}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="9" class="border_col"></td>
                <td colspan="2" class="pa-2 border_col">
                  <div class=" ma-4">
                    <div>ส่วนลดท้ายบิล</div>
                  </div>
                </td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <div class="ma-4">
                      <div class="text-center">{{ header_list.discount }}</div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="9" class="border_col"></td>
                <td colspan="2" class="border_col">
                  <div class="ml-2 mb-7">ราคาสินค้าไม่รวมภาษี</div>
                  <div class="ml-2 pt-1">ภาษีมูลค่าเพิ่ม 7%</div>
                </td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4 text-center">{{ no_vat }}</div>
                  <v-divider/>
                  <div class="ma-4 text-center">{{ cal_vat }}</div>
                </td>
              </tr>
              <tr>
                <td colspan="9" class="border_col"></td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <div>จำนวนเงินทั้งสิ้นรวมภาษี</div>
                  </div>
                </td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <div class="text-center">{{ format_Price(header_list.total = (total_all - header_list.discount)) }}</div>
                  </div>
                </td>
              </tr>
              <v-divider/>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import {diffChangeFormat, diffDateTH, formatNumber, formatPrice} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "PU_details_pr",
  data() {
    return {
      search: '',
      loading_page: false,
      alert_success: false,
      alert_danger: false,
      date: '',
      date_due: '',
      Pr_List: [
        {
          text: 'ลำดับ',
          value: 'index',
          fixed: true,
          width: '120px',
        },
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '125px',
        },
        {
          text: 'ล็อต',
          value: 'lot_no',
          fixed: true,
          width: '150px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          fixed: true,
          width: '300px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'วันที่หมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'price',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ส่วนลด(บาท)',
          value: 'discount_unit',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ส่วนลด(%)',
          value: 'discount_percent',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคารวม',
          value: 'total_price',
          fixed: true,
          width: '150px',
        },
        {
          text: 'สินค้ารอคืน',
          value: 'exchange_status',
          sortable: false,
          fixed: true,
          width: '150px',
        },
      ],
      header_list: [],
      data_list: [],
    }
  },
  methods: {
    diffDate_TH: function(value) {
      return diffDateTH(value)
    },
    format_Price: function(value) {
      return formatPrice(value)
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    diffTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'/'+month+'/'+year
      return this.date = final_date
    },
    diffDueTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'/'+month+'/'+year
      return this.date_due = final_date
    },
    diffDate_Change: function(value) {
      return diffChangeFormat(value)
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/creditor/pupr', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.header_list = res.data.pr_head
          if (res.data.pr_head.receipt_date !== null) {
            this.date = res.data.pr_head.receipt_date
            this.diffTH(this.date)
          }
          else {
            this.date = ''
          }
          if (res.data.pr_head.credit_date !== null) {
            this.date_due = res.data.pr_head.credit_date
            this.diffDueTH(this.date_due)
          }
          else {
            this.date_due = ''
          }
          this.data_list = res.data.pr_detail_lists
        }
      })
    },
  },
  computed: {
    total() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum, number) => {
        let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;
        if (total_price < 0) {
          return sum+(0);
        }
        else {
          return sum+(total_price);
        }
      }, 0)
      return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    no_vat() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum,number) => {
        if (this.header_list.vat_type == 0){
          let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;
          let in_vat = ((total_price * 7)/107);
          let total_grand = total_price - in_vat
          if (total_grand < 0) {
            return sum+(0);
          }
          else {
            return sum+(total_grand);
          }
        }
        else if(this.header_list.vat_type == 1) {
          let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;          if (total_price < 0) {
            return sum+(0);
          }
          else {
            return sum+((total_price));
          }
        }
        else if(this.header_list.vat_type == 2) {
          let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;          if (total_price < 0) {
            return sum+(0);
          }
          else {
            return sum+((total_price));
          }
        }
        else if(this.header_list.vat_type == 3) {
          let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;          if (total_price < 0) {
            return sum+(0);
          }
          else {
            return sum+((total_price));
          }
        }
      }, 0)
      return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    cal_vat() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum,number) => {
        if (this.header_list.vat_type == 0) {
          let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;          let calculate = ((total_price * 7)/107);
          return sum+(calculate);
        }
        else if (this.header_list.vat_type == 1){
          let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;          let calculate = (total_price * (7/100));
          return sum+(calculate);
        }
        else if (this.header_list.vat_type == 2){
          return sum+(0);
        }
        else if (this.header_list.vat_type == 3){
          return sum+(0);
        }
      }, 0)
      return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    total_all() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum,number) => {
        if (this.header_list.vat_type == 0){
          let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;          if (total_price < 0) {
            return sum+(0)
          }
          else {
            return sum+(total_price);
          }
        }
        else if(this.header_list.vat_type == 1) {
          let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;          let ex_vat = ((total_price * 7)/100);
          if (total_price < 0) {
            return sum+(0)
          }
          else {
            return sum+(total_price + ex_vat);
          }
        }
        else if(this.header_list.vat_type == 2) {
          let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;          if (total_price < 0) {
            return sum+(0)
          }
          else {
            return sum+(total_price);
          }
        }
        else if(this.header_list.vat_type == 3) {
          let total_price = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.quantity) - number.discount_unit;          if (total_price < 0) {
            return sum+(0)
          }
          else {
            return sum+(total_price);
          }
        }
      }, 0)
      return result;
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.border_col {
  border-left: #f1f1f1 solid 2px;
  border-right: #f1f1f1 solid 2px;
}
.grid_row {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}
.grid_list  {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}
.grid_vat {
  display: grid;
  grid-template-columns: 50% 50%;
}
@media only screen and (max-width: 1100px){
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_vat {
    display: grid;
    grid-template-columns: 45% 55%;
  }
}
@media only screen and (max-width: 700px){
  .grid_list {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_vat {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
</style>
